module.exports = __webpack_public_path__ + "img/gold.2d4e584d.png";